export default __webpack_public_path__ + "static/ak-cached/24h/media/samsung-nonvzw.1148f2ad.png";